import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

/**
 * This function renders the Space Travel page
 * @return {Component} SpaceTravelPage component
 */
export default function SpaceTravelPage() {
  return (
    <Card style={{
      padding: '50px',
      width: '1200px',
      margin: '30px',
    }}>
      <Grid item xs={12} md={8}>
        <Typography variant="h6" gutterBottom>
          <h1>Space Travel</h1>
        </Typography>
        <Divider />
        <p style={{fontSize: '16px', lineHeight: '24px'}}>
            Sophisticated space travel is more than a program goal. Effective,
            safe transportation is a requirement for the future of galactic
            exploration, expansion, and the progression of thousands of
            government- and private-sector technologies that will deliver
            America to the stars. There is a superior economy waiting in
            durable space exploration. Advanced Intelligence Services Corp. is
            working to invent new materials for spacecraft development, such as
            exterior surface substances designed to reduce the impact of
            propulsion and improve the sustainability of next-generation
            vehicles by harnessing the natural power of physics. In the future,
            space travel is likely to be quite different than it is today.
            Pre-expression matter drives, scalable operating environments, and
            perpetual life support systems are certain to be a part of that
            future. The challenge is real, and it will become increasingly
            necessary for America to gather education, resources, and
            multi-circa support for the success of next-generation exploration
            and expansion operations, both in and beyond our galaxy.
        </p>
      </Grid>
    </Card>
  );
}
